// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-logo {
  font-size: small;
  width: 10%;
  height: 10%;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlcG9ydC1wcmludGVyLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQkFBZ0I7RUFDaEIsVUFBVTtFQUNWLFdBQVc7QUFDYiIsImZpbGUiOiJyZXBvcnQtcHJpbnRlci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnJlcG9ydC1sb2dvIHtcbiAgZm9udC1zaXplOiBzbWFsbDtcbiAgd2lkdGg6IDEwJTtcbiAgaGVpZ2h0OiAxMCU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/core/components/report/report-printer/report-printer.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA,wYAAwY","sourcesContent":[".report-logo {\n  font-size: small;\n  width: 10%;\n  height: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
